"use client";

import { useEffect } from "react";
import { ErrorFallback } from "@/components/ErrorFallback";
import { isDOMManipulationError, reportDOMErrorToDatadog } from "@/utils/errorReporting";

/**
 * Global error boundary for Next.js App Router.
 * This catches errors that occur during rendering, including:
 * - DOM manipulation conflicts between React and third-party scripts (VWO, GTM, react-svg)
 * - "Failed to execute 'removeChild' on 'Node'" errors during SPA navigation
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (isDOMManipulationError(error)) {
      reportDOMErrorToDatadog(error, "global");
    } else {
      console.error("Global error caught:", error);
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        <ErrorFallback onReset={reset} />
      </body>
    </html>
  );
}
